export enum URLEnums {
    AOS_Front_EU,
    AOS_Front_COM,
    AOS_Front_NET,
    AOS_Back_EU,
    AOS_Back_COM,
    AOS_Back_NET
}
export enum PlatformEnum {
    EU,
    NET,
    US
}


export const urls = (url: URLEnums) => {
    switch (url) {
        case URLEnums.AOS_Front_EU:
            return 'https://aos-cloud.myamadeo.eu';
        case URLEnums.AOS_Front_COM:
            return 'https://aos-cloud.myamadeo.com';
        case URLEnums.AOS_Front_NET:
            return 'https://aos-cloud.myamadeo.net';
        case URLEnums.AOS_Back_EU:
            return 'https://www.skyaccess.eu/IntegraAdminAPI';
        case URLEnums.AOS_Back_COM:
            return 'https://www.skyaccess.us/IntegraAdminAPI';
        case URLEnums.AOS_Back_NET:
            return 'https://aos-api.myamadeo.net';
        default:
            return '';
    }
}

// export const urlsLocal = (url: URLEnums) => {
//     switch (url) {
//         case URLEnums.EU_AOS:
//             return 'https://localhost:44339';
//         case URLEnums.EU_FREEFLEX:
//             return 'https://localhost:44356';
//         case URLEnums.NET_AOS:
//             return 'https://localhost:44339';
//         case URLEnums.NET_FREEFLEX:
//             return 'https://localhost:44356';
//         case URLEnums.US_AOS:
//             return 'https://localhost:44339';
//         case URLEnums.US_FREEFLEX:
//             return 'https://localhost:44356';
//         default:
//             return '';
//     }
// }

